import { SET_CURRENT_USER } from "../actions/current_user";

const default_state = null;

const current_user = (state = default_state, action) => {
  switch (action.type) {
    case SET_CURRENT_USER: {
      return action.payload;
    }
    default:
      return state;
  }
};

export default current_user;
